export default [

     {
          path: '/measure-classification',
          name: 'MeasureClassification',
          component: () => import("@/views/Page/MeasureClassification/MeasureClassification.vue"),
          meta: {
               title: 'Measure Classification',
          },
     }
];